import type {KanbanSortBy} from '@dms/api/core';

export const KANBAN_DEFAULT_SORT_BY: KanbanSortBy = 'CREATED_AT_DESC';
